import api from './index'

class UserService {
	fetchUser() {
		return api.get('/users')
	}
	getPermissions() {
		return api.get('/users/permissions')
	}
	addUser(data) {
		return api.post('/users', data)
	}
	editUser(username, data) {
		return api.post(`/users/${username}`, data)
	}

	generate2FA(userID) {
		return api.get(`/users/2fa/${userID}/generate`)
	}
	enable2FA(userID, payload) {
		return api.post(`/users/2fa/${userID}/enable`, payload)
	}
	disable2FA(userID) {
		return api.post(`/users/2fa/${userID}/disable`)
	}
}

export default new UserService()
